<aside id="pa-toasts-block">
    <div class="pa-toasts-container">
        <div #toastsContainer></div>
    </div>
</aside>